import { MARKETING } from './env';

export const getShareMetaDefault = (t) => {
	const shareInfo = {
		HK: {
			author: t('hkShareTitle'),
			defaultShareTitle: t('hkShareTitle'),
			defaultShareDesc: t('hkShareDesc'),
			defaultShareImg: 'https://r.hstong.com/v2/commons/images/h5/share_default.png',
			keywords: t('hkShareDesc'),
		},
		MY: {
			author: 'M+ Global',
			defaultShareTitle: 'M+ Global, winning the world!',
			defaultShareDesc:
				'M+ Global by Malacca Securities is a cutting-edge global trading platform that offers real-time market data with competitive rates',
			defaultShareImg:
				'https://r.global.mplusonline.com/fe/hs-my-res/commons/images/logo/share.png',
			keywords:
				'M+ Global by Malacca Securities is a cutting-edge global trading platform that offers real-time market data with competitive rates',
		},
	};
	return shareInfo[MARKETING];
};
